export enum RidesExtraFields {
  IsInvoiceable = 2, //bool
  NumberOfStops = 4, //int
  NumberOfStudents = 6, //int
  NumberOfAides = 7, //int
  NumberOfAssistants = 8, //int
  TotalNumberOfStudentEquipment = 10, //int
  IsTest = 12, //bool
  NumberOfAttendants = 13, //int
  IsSubDriver = 16, //bool
  IsHasInternalNote = 17, //bool
  AdjustmentApplied = 24, //long
  State = 25, //string
  County = 26, //string
  Type = 29, //string
  VehicleTypeName = 30, //string
  Period = 31, //string
  DistanceBased = 32, //string
  ScheduleTimeAdjustments = 34, //int
  ContractorOriginalPayout = 35, //double
  DriverPayout = 36, //double
  AssignmentDetails = 37, //string
  BlueprintDriverPayout = 38, //string
  DriverNote = 39, //string
  LocationLatitude = 40, //string
  ServiceRegionId = 41, //long
  LocationLongitude = 42, //string
  IsHavePayoutLineItem = 43, //bool
  EquipmentsNeed = 45, // number
  CancellationReasons = 46, // number
  GeoFenceRadius = 47, // number
  CancellationReasonNote = 48
}
export enum RideStopExtraFields {
  IsTimeAnchor = 4, //bool
  QualityScoreItems = 5, //long
  FullAddress = 6, //string
  Street1 = 7, //string
  Street2 = 8, //string
  City = 9, //string
  State = 10, //string
  County = 11, //string
  Country = 12, //string
  Type = 14, //string
  Name = 15, //string
  PlaceName = 16, //string
  DriverNote = 23, //string
  Location = 24, //string
  Zipcode = 25, //string
  IsAutomatic = 26, //string
  DelayReason = 27, //string
}
export enum RideCargoExtraFields {
  Type = 1, //string
  PassengerType = 2, //string
  FirstName = 3, //string
  LastName = 4, //string
  MiddleName = 5, //string
  ProfilePhotoCdnUrl = 6, //string
  PayingClientName = 7, //string
  VehicleType = 8, //string
  NoShowValue = 9, //double
  StudentContacts = 10, //string
  DriverNote = 12, //string
  IsTransportationConfirmed = 13, //boolean
  IsSensitiveRide = 14, //boolean
  PreferredDriverGenderId = 15, //boolean
  IsCameraRequired = 16, //boolean
}
export enum RideJobExtraFields {
  Type = 1, //string
  PartnerFirstOrNickName = 2, //string
  IsTest = 3, //bool
  DriverNote = 4, //string
  RideQualityScoreItems = 5, //long
  PayoutAdjustment = 7,
}
export enum RideDriverExtraFields {
  OrganizationName = 1, //string
  FirstName = 2, //string
  LastName = 3, //string
  NickName = 4, //string
  MiddleName = 5, //string
  ProfilePhotoCdnUrl = 6, //string
  DriverLicenseNumber = 7, //string
  DriverLicenseStatus = 8, //string
  PhoneNumber = 9, //string
  Languages = 10, //string
  ComplianceStatus = 11, //string
  DriverNote = 12, //string
  VehicleColor = 13, //string
  VehicleModel = 14, //string
  VehiclePlateNumber = 15, //string
  VehicleMake = 16, //string
  Year = 17, //string
  Classification = 18, //string
  EquipmentIds = 19, //string
}
